<template>
  <v-container>
    <Filters :items="listMaster" />
    <DataTable
      :loading="loading"
      :items="listFiltered"
      :items-per-page.sync="itemsPerPage"
      @refresh="findAllProcess"
    />
  </v-container>
</template>

<script>
import Service from '../../../../services/MonitoringCockpitService'
import DataTable from './DataTable'
import Filters from './Filters'

export default {
  name: 'Integrations',

  components: { Filters, DataTable },

  data: () => ({
    loading: true,
    refreshItemsPerPage: true,
    refreshListFiltered: true,
    listMaster: []
  }),

  created () { this.findAllProcess() },

  computed: {
    listFiltered () {
      const { refreshListFiltered } = this // eslint-disable-line no-unused-vars
      const { integrationIDFilter, activeFilter, processTypeFilter } = this.$route.query
      console.debug('ActiveFilter Desativado temporariamente nos parametros de urlQuery. Valor atual:' + activeFilter)
      return this.listMaster
        .filter(i => !integrationIDFilter || i.integrationID === integrationIDFilter)
        .filter(i => !processTypeFilter || i.processType === processTypeFilter)
        // .filter(i => activeFilter === '' || i.active.toString() === activeFilter)
        .sort((first, second) => second.lastDate - first.lastDate)
    },
    itemsPerPage: {
      get () {
        const { refreshItemsPerPage } = this // eslint-disable-line no-unused-vars
        return this.$cookies.isKey('monitoring_integrations_per_page') ? parseInt(this.$cookies.get('monitoring_integrations_per_page')) : 10
      },
      set (value) {
        this.$cookies.set('monitoring_integrations_per_page', value)
        this.refreshItemsPerPage = !this.refreshItemsPerPage// It's to force a recompute of 'itemsPerPage' !
      }
    }
  },

  methods: {
    findAllProcess () {
      this.loading = true
      Service.allIntegrations()
        .then(response => { this.listMaster = response.data })
        .catch(error => console.error(this.$t('warnings.error.occurred'), error))
        .finally(() => { this.loading = false })
    },
    refreshQueryParams () { this._refreshQueryParams_ = !this._refreshQueryParams_ }
  },

  watch: {
    numberLines: 'findAllProcess',
    '$route.query' () { this.refreshListFiltered = !this.refreshListFiltered }
  }
}
</script>
